import type { ApplicationAgent } from '@app/services/ApplicationAgent'

import { createThunk } from '@app/store/thunk'

export const getApplicationAgent = () =>
  createThunk((_dispatch, _getState, context) => {
    return context.getRootContext().lookupEnsure<ApplicationAgent>(ApplicationAgentSymbol)
  })

export const setApplicationAgent = (agent: ApplicationAgent) =>
  createThunk((_dispatch, _getState, context) => {
    context.getRootContext().set(ApplicationAgentSymbol, agent)
  })

const ApplicationAgentSymbol = Symbol('applicationAgent')
